import PastImageItem from './PastImageItem';

export default PastImageItem;
